
   <div class="brook-player-area bg_color--1 pb--150 pt--120 pt_md--80 pt_sm--80  pb_md--80 pb_sm--80">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title normal-text text-center wow move-up">
                    <h3>HTML5 Audio</h3>
                    <h2>You can use single or multiple column to display HTML5 Audios.</h2>
                </div>
            </div>
        </div>
        <div class="row mt--70 mt_sm--20 mt_md--30">
           
            <h1>hola</h1>
            <audio controls>
                <source src="../../../assets/ciclo_21_dias/meditacion_1.mp4" type="audio/ogg">
                <source src="../../../assets/ciclo_21_dias/meditacion_2.mp4" type="audio/mpeg">
              Your browser does not support the audio element.
              </audio>
        </div>
    </div>
</div>
<!-- End Audio Player Area -->